import { render, staticRenderFns } from "./CalendarHolidayLegend.vue?vue&type=template&id=e1bfbd4a&scoped=true&"
import script from "./CalendarHolidayLegend.vue?vue&type=script&lang=js&"
export * from "./CalendarHolidayLegend.vue?vue&type=script&lang=js&"
import style0 from "./CalendarHolidayLegend.vue?vue&type=style&index=0&id=e1bfbd4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1bfbd4a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e1bfbd4a')) {
      api.createRecord('e1bfbd4a', component.options)
    } else {
      api.reload('e1bfbd4a', component.options)
    }
    module.hot.accept("./CalendarHolidayLegend.vue?vue&type=template&id=e1bfbd4a&scoped=true&", function () {
      api.rerender('e1bfbd4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/components/day-legend/CalendarHolidayLegend.vue"
export default component.exports